import * as CommonActions from "./commonActions";

export default CommonActions;



// WEBPACK FOOTER //
// ./src/actions/CommonActions/index.js